module.exports = __webpack_public_path__ + "public/images/modals/netw-choose-company-tablet.48086af5417562c345d9487721e1d8a5.png";